import React from "react";
import Slider from "react-slick";
import TelevisionBreakpoint from "../../../../components/responsive_utilities/television_breakpoint";
import DesktopBreakpoint from "../../../../components/responsive_utilities/desktop_breakpoint";
import TabletBreakpoint from "../../../../components/responsive_utilities/tablet_breakpoint";
import PhoneBreakpoint from "../../../../components/responsive_utilities/phone_breakpoint";

export class AnglerScores extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      anglerScores: [],
			juniorScores: [],
			femaleScores: [],
      anglerTotals: [],
			femaleTotals: [],
			juniorTotals: [],
      anglerScoresArray: [],
      logs: this.props.logs,
      anglers: this.props.anglers,
      species: this.props.species
    }
  }
  
  componentWillReceiveProps(newProps) {
    this.setState({logs: newProps.logs, anglers: newProps.anglers, species: newProps.species});
		if(newProps.logs.length > 0) {
			this.getAnglerPoints();
		}
  }

  getAnglerPoints() {
		console.log('Logs: ', this.state.logs)
    var anglersArray = Object.entries(this.state.anglers);
    var anglerFishLogs = [];
		var anglerFishLogsFemale = [];
		var anglerFishLogsJunior = [];
    var anglerTotals = [];
    anglersArray.forEach((angler) => {
      var anglerFish = [];
			if(this.state.logs.length > 0) {
				this.state.logs.forEach((log) => {
					if(log.boatCaughtFish) {
						log.boatCaughtFish.forEach((fish) => {
							if(fish.anglerId === angler[0]) {
								anglerFish.push(fish);
							}
						})
					}
				})
			}
      if(anglerFish.length >0) {
         anglerFish.sort(function(a, b) {
            var dateA = new Date(a.catchDate), dateB = new Date(b.catchDate);
            return dateA - dateB;
        });
        var lastFishInt = (anglerFish.length - 1);
        var lastFishTime = anglerFish[lastFishInt].catchDate;
        anglerFishLogs.push({
          anglerId: angler[0],
          anglerFirst: angler[1].firstName,
          anglerLast: angler[1].lastName,
          anglerClass: angler[1].class,
          anglerSex: angler[1].sex,
          anglerThm: angler[1].profileImage,
          anglerFish,
          lastFishTime
        })
      }
    })
		
    anglerFishLogs.forEach((anglerLog) => {
      var speciesArray = Object.entries(this.state.species) || {};
      var logs = anglerLog.anglerFish;
      var anglerCounts = [];
      var anglerPoints = [];
      var anglerTotal = '';
      speciesArray.forEach((specie) => {
        var speciesId = specie[0]
        var speciesName = specie[1].name;
        var speciesPoints = specie[1].points;
        var scoreType = specie[1].scoreType;
        var speciesCount = [];
        var speciesScores = 0;
        if (scoreType === 'QTY'){
          logs.forEach((log) => {
            if(specie[0] === log.speciesId) {
              speciesCount.push(log.id);
            }
          }); 
          var count = speciesCount.length;
          var points = parseFloat(count * speciesPoints);
          var totalPoints = (points + speciesScores)
          anglerCounts.push({
            id: speciesId,
            anglerFirst: anglerLog.anglerFirst,
            anglerLast: anglerLog.anglerLast,
            anglerClass: anglerLog.anglerClass,
            anglerSex: anglerLog.anglerSex,
            anglerThm: anglerLog.anglerThm,
            speciesName: speciesName,
            speciesCount: speciesCount.length,
            speciesPoints: totalPoints
          });
          anglerPoints.push(totalPoints);
        }
				
      });
      anglerTotal = anglerPoints.reduce(function(sum, value) {
        return sum + value;
      }, 0);
      anglerTotals.push({
        id: anglerLog.boatId,
        anglerFirst: anglerLog.anglerFirst,
        anglerLast: anglerLog.anglerLast,
        anglerThm: anglerLog.anglerThm,
        anglerClass: anglerLog.anglerClass,
        anglerSex: anglerLog.anglerSex,
        speciesCounts: anglerCounts,
        total: anglerTotal,
        lastFishTime: this.formatDate(anglerLog.lastFishTime)
      })
      this.setState({
        anglerTotals: anglerTotals
      })
    })
    this.scoreSortFilter();
  }
  
  scoreSortFilter() {
    var anglerScores = this.state.anglerTotals;
    Array.prototype.sortOn = function(key, key2){
      this.sort(function(a, b){
          if(a[key] < b[key]){
              return -1;
          }else if(a[key] > b[key]){
              return 1;
          } else {
            if(a[key2] > b[key2]){
              return -1;
            }else if(a[key2] < b[key2]){
              return 1;
            }
          }
          return 0;
      });
    }
    
    anglerScores.sortOn("total", "lastFishTime");
    anglerScores.reverse();
    
    function isNumber(obj) {
      return obj!== undefined && typeof(obj) === 'number' && !isNaN(obj);
    }

    function filterByTotal(item) {
      if (isNumber(item.total)) {
        return true;
      } 
      return false; 
    }
    var anglerScoresArray = anglerScores.filter(filterByTotal);
		const femaleTotals = anglerScoresArray.filter(anglerTotal => anglerTotal.anglerSex === 'Female');
		const juniorTotals = anglerScoresArray.filter(anglerTotal => anglerTotal.anglerClass === 'Junior');
    
    var rank = 1;
		var juniorRank = 1;
		var femaleRank = 1;
    var aScores = [];
		var juniorScores = [];
		var femaleScores = [];
		
    anglerScoresArray.forEach((angler) => {
      aScores.push({
        rank: rank++,
        angler
      })
			if(angler.anglerSex === 'Female') {
				femaleScores.push({
					femaleRank: femaleRank++,
					angler
				})
			}
			if(angler.anglerClass === 'Junior') {
				juniorScores.push({
					juniorRank: juniorRank++,
					angler
				})
			}
    })
    
    this.setState({
      anglerScores: aScores,
			juniorScores: juniorScores,
			femaleScores: femaleScores,
      anglerScoresArray,
    })  
  }
  
  formatDate(date) {
    var options = {
      month: 'short', day: 'numeric',
      hour: 'numeric', minute: 'numeric',
      hour12: true,
      timeZone: 'America/Costa_Rica',
    };
    var newDate = new Date(date);
		var secs = new Date(newDate).getTime() / 1000;
    var formattedDate = new Intl.DateTimeFormat('en-US', options).format(newDate);

    return secs;
  }
  
  render() {
    var topAngler = this.state.anglerScores[0];
		const settingsPhone = {
			customPaging: function(i) {
        return (
          <a>
            {i + 1}
          </a>
        );
      },
      dots: true,
			dotsClass: "slick-dots slick-thumb",
      arrows: false,
      infinite: true,
			autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 5,
      slidesToScroll: 5,
      swipeToSlide: true,
			vertical: true,
    };
    var settings = {
      customPaging: function(i) {
        return (
          <a>
            {i + 1}
          </a>
        );
      },
      dots: true,
			dotsClass: "slick-dots slick-thumb",
      arrows: false,
      infinite: false,
			autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 2,
      slidesToScroll: 2,
      swipeToSlide: true,
			vertical: true,
    };
		var settingsAnglers = {
      customPaging: function(i) {
        return (
          <a>
            {i + 1}
          </a>
        );
      },
      dots: true,
			dotsClass: "slick-dots slick-thumb",
      arrows: false,
      infinite: false,
			autoplay: false,
      autoplaySpeed: 4000,
      slidesToShow: 5,
      slidesToScroll: 5,
      swipeToSlide: true,
			vertical: true,
    };
		
    return (
      <div className="box-topAnglers">
				<TelevisionBreakpoint>
					<div className="anglers-container"> 
						{ topAngler ? <div className="anglers-box">
							<div className="topAngler">
								Top Female Angler
							</div>
							<div className="top-title">{topAngler.angler.total} Pts.</div>
							<div className="anglerTitle">
							{topAngler.angler.anglerFirst} {topAngler.angler.anglerLast}
							</div>
						</div>: null}
					</div>
				</TelevisionBreakpoint>
				<DesktopBreakpoint>
					<div className="anglers-container"> 
						{ topAngler ? <div className="anglers-box">
							<div className="topAngler">
								Top Female Angler
							</div>
							<div className="top-title">{topAngler.angler.total} Pts.</div>
							<div className="anglerTitle">
								{topAngler.angler.anglerFirst} {topAngler.angler.anglerLast}
							</div>
						</div>: null}
					</div>
				</DesktopBreakpoint>
				<TabletBreakpoint>
					<div className="smv-scoreContainer"> 
						<div className="score_box_title">Top Angler</div>
						{this.state.anglerScores.length > 0 ? <Slider {...settings}>
								{this.state.anglerScores.map(angler => (
									<div className="smv-boatBox" key={angler.id}>
											<div id='boat-total' className="smv-logCellPhone">
												<div  className="smv-cellDetailsBox">
													<div className="smv-rankBox1">
														# {angler.rank} {angler.angler.anglerFirst} {angler.angler.anglerLast}
													</div>
												</div>
												<div id='boat-total' className="smv-boat-total-box">
													{angler.angler.speciesCounts ? angler.angler.speciesCounts.map(specie => (
														<div className="speciesNumsRow">
															<div className="speciesNumsBox">
																<div className="speciesNums2">
																	 {specie.speciesCount ?specie.speciesCount: null}
																 </div> 
																<div className="speciesNumsTitle">
																	{specie.speciesCount ? specie.speciesName: null}
																</div>
															</div>
														</div>
													)) : null }
													<div className="boatPoints">
														{angler.angler.total} pts
													</div>
												</div>
											</div>
									</div>
								))}
							</Slider> : <div className="smv-speciesName" >No billfish logged yet.</div> 
						}
						</div>
						<div className="smv-scoreContainer"> 
						<div className="score_box_title">Top Female Angler</div>
						{this.state.femaleScores.length > 0 ? <Slider {...settings}>
								{this.state.femaleScores.map(angler => (
									<div className="smv-boatBox" key={angler.id}>
											<div id='boat-total' className="smv-logCellPhone">
												<div  className="smv-cellDetailsBox">
													<div className="smv-rankBox1">
														# {angler.femaleRank} {angler.angler.anglerFirst} {angler.angler.anglerLast}
													</div>
												</div>
												<div id='boat-total' className="smv-boat-total-box">
													{angler.angler.speciesCounts ? angler.angler.speciesCounts.map(specie => (
														<div className="speciesNumsRow">
															<div className="speciesNumsBox">
																<div className="speciesNums2">
																	 {specie.speciesCount ?specie.speciesCount: null}
																 </div> 
																<div className="speciesNumsTitle">
																	{specie.speciesCount ? specie.speciesName: null}
																</div>
															</div>
														</div>
													)) : null }
													<div className="boatPoints">
														{angler.angler.total} pts
													</div>
												</div>
											</div>
									</div>
								))}
							</Slider> : <div className="smv-speciesName" >No billfish logged yet.</div> 
						}
					</div>
					<div className="smv-scoreContainer"> 
						<div className="score_box_title">Top Junior Angler</div>
						{this.state.juniorScores.length > 0 ? <Slider {...settings}>
								{this.state.juniorScores.map(angler => (
									<div className="smv-boatBox" key={angler.id}>
											<div id='boat-total' className="smv-logCellPhone">
												<div  className="smv-cellDetailsBox">
													<div className="smv-rankBox1">
														# {angler.juniorRank} {angler.angler.anglerFirst} {angler.angler.anglerLast}
													</div>
												</div>
												<div id='boat-total' className="smv-boat-total-box">
													{angler.angler.speciesCounts ? angler.angler.speciesCounts.map(specie => (
														<div className="speciesNumsRow">
															<div className="speciesNumsBox">
																<div className="speciesNums2">
																	 {specie.speciesCount ?specie.speciesCount: null}
																 </div> 
																<div className="speciesNumsTitle">
																	{specie.speciesCount ? specie.speciesName: null}
																</div>
															</div>
														</div>
													)) : null }
													<div className="boatPoints">
														{angler.angler.total} pts
													</div>
												</div>
											</div>
									</div>
								))}
							</Slider> : <div className="smv-speciesName" >No billfish logged yet.</div> 
						}
					</div>
				</TabletBreakpoint>
				<PhoneBreakpoint>
					<div className="smv-scoreContainer"> 
						<div className="score_box_title">Top Angler</div>
						{this.state.anglerScores.length > 0 ? <Slider {...settingsAnglers}>
								{this.state.anglerScores.map(angler => (
									<div className="smv-boatBox" key={angler.id}>
											<div id='boat-total' className="smv-logCellPhone">
												<div  className="smv-cellDetailsBox">
													<div className="smv-rankBox1">
														# {angler.rank} {angler.angler.anglerFirst} {angler.angler.anglerLast}
													</div>
												</div>
												<div id='boat-total' className="smv-boat-total-box">
													{angler.angler.speciesCounts ? angler.angler.speciesCounts.map(specie => (
														<div className="speciesNumsRow">
															<div className="speciesNumsBox">
																<div className="speciesNums2">
																	 {specie.speciesCount ?specie.speciesCount: null}
																 </div> 
																<div className="speciesNumsTitle">
																	{specie.speciesCount ? specie.speciesName: null}
																</div>
															</div>
														</div>
													)) : null }
													<div className="boatPoints">
														{angler.angler.total} pts
													</div>
												</div>
											</div>
									</div>
								))}
							</Slider> : <div className="smv-speciesName" >No billfish logged yet.</div> 
						}
						</div>
						<div className="smv-scoreContainer"> 
						<div className="score_box_title">Top Female Angler</div>
						{this.state.femaleScores.length > 0 ? <Slider {...settings}>
								{this.state.femaleScores.map(angler => (
									<div className="smv-boatBox" key={angler.id}>
											<div id='boat-total' className="smv-logCellPhone">
												<div  className="smv-cellDetailsBox">
													<div className="smv-rankBox1">
														# {angler.femaleRank} {angler.angler.anglerFirst} {angler.angler.anglerLast}
													</div>
												</div>
												<div id='boat-total' className="smv-boat-total-box">
													{angler.angler.speciesCounts ? angler.angler.speciesCounts.map(specie => (
														<div className="speciesNumsRow">
															<div className="speciesNumsBox">
																<div className="speciesNums2">
																	 {specie.speciesCount ?specie.speciesCount: null}
																 </div> 
																<div className="speciesNumsTitle">
																	{specie.speciesCount ? specie.speciesName: null}
																</div>
															</div>
														</div>
													)) : null }
													<div className="boatPoints">
														{angler.angler.total} pts
													</div>
												</div>
											</div>
									</div>
								))}
							</Slider> : <div className="smv-speciesName" >No billfish logged yet.</div> 
						}
					</div>
					<div className="smv-scoreContainer"> 
						<div className="score_box_title">Top Junior Angler</div>
						{this.state.juniorScores.length > 0 ? <Slider {...settings}>
								{this.state.juniorScores.map(angler => (
									<div className="smv-boatBox" key={angler.id}>
											<div id='boat-total' className="smv-logCellPhone">
												<div  className="smv-cellDetailsBox">
													<div className="smv-rankBox1">
														# {angler.juniorRank} {angler.angler.anglerFirst} {angler.angler.anglerLast}
													</div>
												</div>
												<div id='boat-total' className="smv-boat-total-box">
													{angler.angler.speciesCounts ? angler.angler.speciesCounts.map(specie => (
														<div className="speciesNumsRow">
															<div className="speciesNumsBox">
																<div className="speciesNums2">
																	 {specie.speciesCount ?specie.speciesCount: null}
																 </div> 
																<div className="speciesNumsTitle">
																	{specie.speciesCount ? specie.speciesName: null}
																</div>
															</div>
														</div>
													)) : null }
													<div className="boatPoints">
														{angler.angler.total} pts
													</div>
												</div>
											</div>
									</div>
								))}
							</Slider> : <div className="smv-speciesName" >No billfish logged yet.</div> 
						}
					</div>
				</PhoneBreakpoint>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/tournaments/pelagicPV/comps/AnglerScores.js